<template>
  <span class="relative inline-block ml-2">
    <span @click.stop="toggle" class="cursor-pointer text-blue-500">ℹ️</span>

    <div
        v-if="show"
        class="absolute right-0 z-10 mt-2 p-2 w-64 bg-white text-sm border border-gray-300 rounded shadow-lg"
        style="min-width: 200px;"
    >
      This price has been indicated as <i>stale</i>. The price displayed is the last recorded price.
      <button
          @click="toggle"
          class="absolute cursor-pointer top-1 right-2 text-gray-500 hover:text-black text-xs"
      >
        ✕
      </button>
    </div>
  </span>
</template>

<script setup>
    import { ref, onMounted, onBeforeUnmount } from 'vue'

    const show = ref(false)
    const toggle = () => {
        show.value = !show.value;
    }

    // Close when clicked outside of component
    const clickOutside = (e) => {
        if (!e.target.closest('.info-popup')) {
            show.value = false;
        }
    }

    onMounted(() => {
        window.addEventListener('click', clickOutside);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('click', clickOutside);
    });
</script>

<style scoped>
    /* Add a class to identify popup root for outside detection */
    :deep(.info-popup) {
        position: relative;
    }
</style>
